import { render, staticRenderFns } from "./GoldOrderList.vue?vue&type=template&id=a4a05da8&scoped=true"
import script from "./GoldOrderList.vue?vue&type=script&lang=js"
export * from "./GoldOrderList.vue?vue&type=script&lang=js"
import style0 from "./GoldOrderList.vue?vue&type=style&index=0&id=a4a05da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a05da8",
  null
  
)

export default component.exports